import * as React from "react";
const SvgDropdownArrow = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { d: "M6 9L9.89711 4.5H2.10289L6 9Z", fill: "currentColor" })
);
export default SvgDropdownArrow;
